import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';

import { InfoTooltip } from '../../../../components/core';

export type MetricKpiCardProps = {
  title: string;
  value: string;
  description: string;
  infoTooltip?: string;
  isLoading?: boolean;
};

export const MetricKpiCard = ({
  title,
  value,
  description,
  infoTooltip,
  isLoading,
}: MetricKpiCardProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 1.5,
      height: 136,
      p: 1.5,
      border: '1px solid',
      borderColor: 'secondary.main',
      borderRadius: '8px',
      backgroundColor: 'background.paper',
      minWidth: 0,
      flex: 1,
    }}
    data-testid={`ella-metric-${title.toLowerCase().replace(/\s+/g, '-')}`}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1, minHeight: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography
          variant="medium"
          color="text.secondary"
          sx={{ textTransform: 'uppercase', lineHeight: '18px' }}
        >
          {title}
        </Typography>
        {infoTooltip ? (
          <InfoTooltip
            title={infoTooltip}
            placement="top"
            ariaLabel={`More information about ${title}`}
          />
        ) : null}
      </Box>
      {isLoading ? (
        <Skeleton variant="text" width="60%" height={36} />
      ) : (
        <Typography
          variant="huge"
          fontWeight="semibold"
          sx={{ lineHeight: '36px', letterSpacing: '-1.5px', wordBreak: 'break-word' }}
        >
          {value}
        </Typography>
      )}
    </Box>
    <Typography variant="small" color="text.secondary" sx={{ lineHeight: '16px' }}>
      {description}
    </Typography>
  </Box>
);
